import { API_URL } from '../../../app-config/constants';
import type ObjectiveCycleDto from '../../../types/ObjectiveCycleDto';
import { get, post, put, remove } from '../request';

const updateOnCreate = (args: [], x: ObjectiveCycleDto, xs: ObjectiveCycleDto[]) => [x, ...xs];

getById.operation = 'READ';
getById.byId = true;
export function getById(id: string): Promise<ObjectiveCycleDto> {
    return get(`${API_URL}/objective-cycles/` + id);
}

list.operation = 'READ';
list.updateOnCreate = updateOnCreate;
export function list(excludeCompleted = false, excludeArchived = false): Promise<ObjectiveCycleDto[]> {
    return get(`${API_URL}/objective-cycles`, {
        getData: {
            excludeCompleted,
            excludeArchived,
        },
    });
}

export function setPermissions(id: string, userIds: string[]) {
    return put(`${API_URL}/objective-cycles/${id}/permissions`, { postData: userIds });
}

export function addPermissions(id: string, userIds: string[]) {
    return post(`${API_URL}/objective-cycles/${id}/permissions`, { postData: userIds });
}

export function removePermission(id: string, userId: string[]) {
    return remove(`${API_URL}/objective-cycles/${id}/permissions/${userId}`);
}

create.operation = 'CREATE';
export function create(model: unknown, inform: unknown): Promise<ObjectiveCycleDto> {
    return post(`${API_URL}/objective-cycles/guided/create`, { postData: { model, inform } });
}

update.operation = 'COMMAND';
export function update(model: unknown): Promise<ObjectiveCycleDto> {
    return post(`${API_URL}/objective-cycles/guided/edit`, { postData: { model } });
}
